import { http } from './http';

// Нормализация payload: приводим book и meal к числовым ID
function normalizeMealRecordPayload(p) {
    if (!p || typeof p !== 'object') return p;
    const out = { ...p };
    const b = out.book;
    if (Array.isArray(b)) {
        if (b.length > 0) {
            const first = b[0];
            out.book = typeof first === 'object' && first !== null ? first.id : first;
        } else {
            delete out.book;
        }
    } else if (typeof b === 'object' && b !== null) {
        if ('id' in b) out.book = b.id;
    }

    const m = out.meal;
    if (Array.isArray(m)) {
        if (m.length > 0) {
            const firstM = m[0];
            out.meal = typeof firstM === 'object' && firstM !== null ? firstM.id : firstM;
        } else {
            delete out.meal;
        }
    } else if (typeof m === 'object' && m !== null) {
        if ('id' in m) out.meal = m.id;
    }

    // Приведём quantity к числу при наличии
    if (out.quantity !== undefined) {
        const num = Number(out.quantity);
        if (!Number.isNaN(num)) out.quantity = num;
    }
    return out;
}

export async function listMealRecords(params = {}) {
    const { data } = await http.get('book/meal-records/', { params });
    return data;
}

export async function getMealRecord(id) {
    const { data } = await http.get(`book/meal-records/${id}/`);
    return data;
}

export async function createMealRecord(payload) {
    const normalized = normalizeMealRecordPayload(payload);
    const { data } = await http.post('book/meal-records/', normalized);
    return data;
}

export async function updateMealRecord(id, payload) {
    const normalized = normalizeMealRecordPayload(payload);
    const { data } = await http.patch(`book/meal-records/${id}/`, normalized);
    return data;
}


export async function deleteMealRecord(id) {
    const { data } = await http.delete(`book/meal-records/${id}/`);
    return data;
}